module.exports = __webpack_public_path__ + "img/das-city-escape-game.263b61bb.png";